/** Actions */
import { isElectronApp } from '../../services/crossPlatform/crossPlatformService';
import * as bookActions from '../bookActions';
import * as accountActions from '../accountActions';
import * as classroomActions from '../classroom/classroomActions';
import * as skinActions from '../skinActions';

/**
 * Inject specialization dependency to actions
 */
export let initActionSpecializations = () => {
  if (isElectronApp()) {
    accountActions.configure(require('./account/account.actions.electron.js'));
    bookActions.configure(require('./book/bookActions.electron.js'));
    classroomActions.configure(require('./classroom/classroom.actions.electron.js'));
    if (window.location.protocol === 'http:') {
      skinActions.configure(require('./skin/skinActions.web'));
    } else {
      skinActions.configure(require('./skin/skinActions.electron.js'));
    }
  } else {
    accountActions.configure(require('./account/account.actions.web'));
    bookActions.configure(require('./book/bookActions.web'));
    classroomActions.configure(require('./classroom/classroom.actions.web'));
    skinActions.configure(require('./skin/skinActions.web'));
  }
};
